import base from './base'

const postUserAction = (userActionParams) => {
  return base.post(`/user_actions`, userActionParams).then(resp => resp.data)
}

export default {
  postUserAction: postUserAction,
}
